<template>
  <div class="app-checkout-mnpin-provider-select" :class="[this.wrapperClass, {'embedded': this.embedded}]">
    <SimonModal
      :is-visible="showBrandSearchInfoModal"
      @hide="showBrandSearchInfoModal = false"
      id="brand-info-modal"
    >
      <slot name="txtBrandSearchInfoDescription"></slot>
    </SimonModal>
    <SimonModal
      :is-visible="showNetworkInfoModal"
      @hide="showNetworkInfoModal = false"
      id="network-info-modal"
    >
      <slot name="txtNetworkInfoDescription"></slot>
    </SimonModal>
    <div class="provider-list-loading"
         v-if="storedMNProvidersLoadedStatus === '' || storedMNProvidersLoadedStatus === 'LOADING' || storedDefaultTariffLoadingStatus === 'LOADING'">
      <div class="loader" :class="[{'small': this.embedded}]">
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="error-box"
         v-if="!this.embedded && (storedMNProvidersLoadedStatus === 'ERROR' || storedMNProvidersLoadedStatus === 'INVALID' || storedDefaultTariffLoadingStatus === 'ERROR' || storedDefaultTariffLoadingStatus === 'FAILED')">
      <div>
        <span v-if="storedMNProvidersLoadedStatus === 'ERROR' || storedMNProvidersLoadedStatus === 'INVALID'">
          <slot name="txtErrorLoadingProviderList">(Fehler: 500)</slot>
        </span>
      </div>
    </div>
    <div v-if="storedMNProvidersLoadedStatus === 'LOADED' && storedDefaultTariffLoadingStatus === 'LOADED'">
      <b-form-group class="brand-search-field mandatory no-valid-check-sign"
                    :class="vflowGetFeedbackClasses('inputBrandName')">
        <b-row>
          <b-col :class="['pr-0']">
            <label v-if="!this.embedded" for="provider-select-input-field" class="has-icon"><span><slot
              name="lblYourCurrentBrand"></slot></span>&nbsp;<i @click="trackAndShowBrandSearchInfoModal()"
                                                                class="info-link-icon"></i></label>
            <div class="dropdown-wrapper" @scroll="grabScrollEvent">
              <div class="dropdown" :ref="'dropdown' + $vnode.key">
                <div :id="$vnode.key" class="dropdown-border">
                  <input
                    role="combobox"
                    :aria-live="ariaLiveForInput"
                    :aria-label="ariaLabelForInput"
                    :aria-expanded="searchingBrand ? 'true' : 'false'"
                    aria-autocomplete="both"
                    aria-haspopup="listbox"
                    aria-controls="serviceProviders"
                    id="provider-select-input-field"
                    ref="brandsearchinput"
                    class="form-control"
                    :class="[this.searchingBrand ? 'option-list-active' : '', (inputBrandName !== '' && inputBrandName !== null && this.searchingBrand ? 'clearable' : '')]"
                    type="text"
                    name="search"
                    spellcheck="false"
                    :value="inputBrandName"
                    :placeholder="placeholderForInput"
                    autocomplete="off"
                    @focus="onFocusSelectField(); vflowInputFocused('inputBrandName'); vflowInputFocused('selectedNetwork_')"
                    @keydown="onArrowKeyScroll"
                    @keydown.enter.prevent="onSelectByReturnKey(); vflowInputFocused('selectedNetwork_')"
                    @keydown.esc="exitSearchMode"
                    @input="inputBrandName = $event.target.value; reactOnUserInput(); vflowInputFocused('selectedNetwork_')"
                    @blur="isNavigatingInProviders = false; isUserTyping = false"
                  >
                </div>
                <button :aria-label="this.$slots.buttonClearProviderAltText[0].text" tabindex="0" id="brand-search-clear-input" class="clear-input" v-if="inputBrandName !== '' && inputBrandName !== null && searchingBrand" @click.prevent="clearSelection" @keydown.esc="exitSearchMode"></button>
                <div class="option-list-wrapper"
                     @mousemove="scrollHandlerOnDrag"
                     @drag="scrollHandlerOnDrag"
                     @mouseover="scrollHandlerOnDragCatch"
                     @mouseup="scrollHandlerOnDragEnd"
                     @mouseleave="scrollHandlerOnDragEnd"
                >
                  <!-- Screenreader live region for no results -->
                  <div aria-live="polite" aria-atomic="true" class="sr-only" ref="liveRegion"></div>
                  <div aria-live="assertive" aria-atomic="true" class="sr-only">
                    {{ focus > -1 ? getProviderOptionAriaLabel(filteredSortedFlaggedBrandSelectOptions()[focus]) : '' }}
                  </div>
                  <ul @scroll="scrollHandlerOnScroll"
                      :aria-busy="storedMNProvidersLoadedStatus === 'LOADED' ? 'false' : 'true'"
                      role="listbox"  :aria-label="getSlotText('lblAreaListBox', 'Liste von Anbietern')"
                      id="serviceProviders" :key="componentKey" ref="dropdownListContainer" tabindex="-1"
                      v-if="this.searchingBrand" class="option-list" :class="[this.showPrice ? 'with-price' : '']">
                    <li aria-disabled="true" aria-hidden="true" role="option" id="item-0" class="no-item-found"
                        v-if="!this.filteredSortedFlaggedBrandSelectOptions() || this.filteredSortedFlaggedBrandSelectOptions().length == 0">
                      <slot name="lblBrandSelectNoResults">Keine Ergebnisse</slot>
                    </li>
                    <li v-for="(brand, index) in this.filteredSortedFlaggedBrandSelectOptions()"
                        :class="[{ focus: index === focus }, brand.frequency, { last: findLastHighBrand(brand) }]"
                        :key="brand.brandName"
                        @mouseover.prevent="listItemMouseOver(index)"
                        @mouseleave.prevent="listItemMouseLeave(index)"
                        @click="itemSelection(brand.brandName)"
                        role="option"
                        :id="'item-' + index"
                    >
                      <div class="item-wrapper">
                        <div class="name">{{ brand.brandName }}<span class="matching-provider-code" v-if="!brand.matchByBrandName && brand.matchedByCode !== null">{{ brand.matchedByCode }}</span></div>
                        <div v-if="showPrice && hasTariffPromoPrice(brand)" class="price promo">
                          <span class="stroked-price">{{ formattedPriceWithOption(brand) }}</span>
                          <span class="promoted-price">{{ formattedPromoPriceWithOption(brand) }}</span>
                        </div>
                        <div v-else-if="showPrice" class="price">{{ formattedPriceWithOption(brand) }}</div>
                      </div>
                    </li>
                  </ul>
                  <div ref="scrollHandle" class="scroll-handle" v-if="this.searchingBrand"
                       @mousedown="scrollHandlerOnDragStart"></div>
                </div>
              </div>
            </div>
            <b-form-invalid-feedback v-if="vflowHasFailedRequired('inputBrandName')">
              <slot name="txtOldProviderRequired">Dies ist ein Pflichtfeld.</slot>
            </b-form-invalid-feedback>
            <div class="error-box" v-if="this.unportableFound_ && this.showErrorBoxBelow">
              <slot name="txtNotPortalble"></slot>
            </div>
          </b-col>
        </b-row>
      </b-form-group>

      <CheckoutMnpInCommonlyBrandSelect
        v-if="!this.embedded && (this.searchingBrand || !this.validBrandSelected || this.unportableFound_)"
        @selected="takeCommonlyBrandSelection"
      >
        <template v-for="slot in possibleChildSlotsFor('Common')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </CheckoutMnpInCommonlyBrandSelect>

      <b-form-group class="network-select mandatory radio-group"
                    v-if="!this.embedded && (!this.searchingBrand && this.withNetworkSelect && this.validBrandSelected && this.couldUseNetworkAsQualifier)"
                    :class="vflowGetFeedbackClasses('selectedNetwork_', 'found')">
        <label class="d-inline-block has-icon"><span><slot name="lblYourCurrentNetwork"></slot></span> <i
          @click="showNetworkInfoModal = true" class="info-link-icon"></i></label>
        <b-form-radio-group v-model="selectedNetwork_" @input="tryToDetermineProvider();" class="d-sm-none pr-0">
          <b-form-radio
            class="network-select-item"
            v-for="network in this.selectableNetworks" v-bind:key="network" :value="network"
            @click="vflowInputFocused('selectedNetwork_')"
          >{{ networkNames[network] ? networkNames[network] : network }}
          </b-form-radio>
        </b-form-radio-group>
        <div class="d-none d-sm-block text-center pr-0">
          <div class="switcher" :class="[selectedNetwork_ !== '' ? 'selected' : '']">
            <div class="switcher-item" :class="[selectedNetwork_ == network? 'selected' : '']"
                 @click="selectedNetwork_ = network" v-for="network in this.selectableNetworks" v-bind:key="network"
                 :value="network">
              {{ networkNames[network] ? networkNames[network] : network }}
            </div>
          </div>
        </div>

        <b-form-invalid-feedback v-if="!$v.selectedNetwork_.found">
          <slot name="txtYourCurrentNetworkRequired"></slot>
        </b-form-invalid-feedback>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import syncProperty from '@/mixins/syncProperty'
import CheckoutMnpInCommonlyBrandSelect from '@/components/process/generic/Tariff/MnpIn/CommonlyBrandSelect.vue'
import { BCol, BFormGroup, BFormInvalidFeedback, BRow } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/validators/isValid'
import { required } from 'vuelidate/lib/validators'
import validationFlow from '@/mixins/validators/validationFlow'
import useFeature from '@/mixins/useFeature'
import price from '@/mixins/formatters/price'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'CheckoutMnpInProviderSelect',
  data () {
    return {
      isNavigatingInProviders: false,
      isUserTyping: false,
      componentKey: 0,
      initialized: false,
      searchingBrand: false,
      focus: 0,
      showNetworkInfoModal: false,
      showBrandSearchInfoModal: false,
      determinedProvider: null,
      inputBrandName: '',
      selectedBrandName: '',
      lastInputBeforeApplied: '',
      lastFocusedBrand: '',
      blurredFields: {
        inputBrandName: false,
        selectedNetwork_: false
      },
      liveFeedbackFor: {
        inputBrandName: false,
        selectedNetwork_: false
      },
      mnpOnlyBrandNameReplacements: [],
      networkNames: {
        D1: 'Telekom (D1)',
        D2: 'Vodafone (D2)',
        O2: 'Telefónica (E-Netz)',
        E1: 'Telefónica (E-Netz)'
      },
      scrollHandlerDragging: false,
      scrollHandlerDragStartPos: 0,
      scrollHandlerDragLastPageY: 0,
      doTracking: true,
      liveToggleChar: true,
      filteredProviderList: []
    }
  },
  props: {
    process: {
      type: String,
      default: 'ordering'
    },
    embedded: {
      type: Boolean,
      default: false
    },
    withNetworkSelect: {
      type: Boolean,
      default: true
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    preselectProvider: {
      type: String,
      default: ''
    },
    frontendContext: {
      type: String,
      default: 'checkout'
    },
    quickSelectionBrand: {
      type: String,
      default: ''
    },
    mnpProvidersWithTariffs: {
      type: Array,
      default: () => []
    },
    showErrorBoxBelow: {
      type: Boolean,
      default: true
    }
  },
  mixins: [
    validationMixin,
    isValid,
    syncProperty('active', 'active_'),
    syncProperty('brandName', 'selectedBrandName_'),
    syncProperty('network', 'selectedNetwork_'),
    syncProperty('providerKey', 'providerKey_'),
    syncProperty('providerCode', 'providerCode_'),
    syncProperty('providerNetwork', 'providerNetwork_'),
    syncProperty('relatedTariff', 'relatedTariff_'),
    syncProperty('unportableFound', 'unportableFound_'),
    syncProperty('unportableSelected', 'unportableSelected_'),
    syncProperty('invalid', 'invalid_'),
    syncProperty('forceLiveFeedback', 'forceLiveFeedback_'),
    useFeature('showFeaturePromotion'),
    useFeature('showFeaturePromotionProviderOnly'),
    useFeature('featurePromo2343'),
    validationFlow,
    price
  ],
  components: {
    SimonModal,
    BFormGroup,
    CheckoutMnpInCommonlyBrandSelect,
    BRow,
    BCol,
    BFormInvalidFeedback
  },
  watch: {
    // this event will be triggered when the complete/form validation changed (not on every field validation change)
    '$v.$invalid': function (v) {
      this.invalid_ = v
      this.$emit('update:mnpin-provider-select-validation', v)
    },
    filteredProviderList (newVal) {
      if (!newVal || newVal.length === 0) {
        this.announceToScreenReader(this.getSlotText('lblBrandSelectNoResults', 'Keine Ergebnisse'))
      }
    }
  },
  created () {
    document.addEventListener('click', this.documentClick)
    document.addEventListener('focusout', this.focusChanged)
    if (!this.storedSelectedTariff) {
      this.initialize()
    }
    if (this.storedMNProvidersLoadedStatus === 'ERROR' || this.storedMNProvidersLoadedStatus === 'INVALID') {
      const data = {
        type: 'technical',
        message: 'Technischer Fehler beim Laden der Providerdaten' // TODO: check, if backend-error exists => add to mnpData.js
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('error', data)
      }
    }
  },
  mounted () {
    this.initialized = false

    // check if there's a preselection, apply
    if (this.selectedBrandName_ === '' && this.preselectProvider !== '' && this.isExistingBrand(this.preselectProvider)) {
      this.selectedBrandName_ = this.preselectProvider
    }

    this.unportableFound_ = false
    this.unportableSelected_ = false

    this.inputBrandName = this.selectedBrandName_
    this.itemSelection(this.selectedBrandName_)

    this.$v.$touch()
    this.invalid_ = this.$v.$invalid

    this.initialized = true
  },
  methods: {
    getProviderListLength () {
      this.filteredProviderList = this.filteredBrandSelectOptions()
    },
    announceToScreenReader (message) {
      const region = this.$refs.liveRegion
      if (!region) return
      // They are visually identical, but different in the DOM, which tricks Screenreader into reading the message again.
      const toggleChar = this.liveToggleChar ? '\u200B' : '\u200C'
      region.textContent = message + toggleChar

      this.liveToggleChar = !this.liveToggleChar
    },
    exitSearchMode () {
      this.searchingBrand = false
      this.$refs.brandsearchinput.blur()
    },
    getProviderOptionAriaLabel (brand) {
      let label = brand.brandName

      // Add promo price if available
      if (this.showPrice && this.hasTariffPromoPrice(brand)) {
        label += `, Preis ${this.formattedPromoPriceWithOption(brand)}`
      } else if (this.showPrice) {
        // Add regular price
        label += `, Preis ${this.formattedPriceWithOption(brand)}`
      }

      return label
    },
    getProviderList () {
      this.$store.dispatch(`checkoutv2/${this.process}/_mnpData/getProviderList`)
    },
    ...mapActions('checkout/tariff', [
      'setSelectedTariff',
      'setSelectedTariffToDefault',
      'loadDefaultTariff'
    ]),
    async initialize () {
      await this.loadDefaultTariff()
      await this.getProviderList()
    },
    resetAll () {
      this.resetInputField()
    },
    resetInputField () {
      this.inputBrandName = ''
      this.resetProviderSelection()
    },
    resetProviderSelection () {
      this.providerKey_ = ''
      this.providerCode_ = ''
      this.providerNetwork_ = ''
      this.relatedTariff_ = null
      this.unportableFound_ = false
      this.unportableSelected_ = false
      this.selectedNetwork_ = ''
      this.selectedBrandName = ''
      this.selectedBrandName_ = ''
      this.determinedProvider = null
      this.setSelectedTariffToDefault()
    },
    clearSelection () {
      this.resetAll()
      this.$nextTick(() => {
        this.searchingBrand = true
        setTimeout(() => {
          this.$refs.brandsearchinput.focus()
        }, 50)
      })
      this.$v.inputBrandName.$touch()
      this.$v.selectedNetwork_.$touch()
      this.vflowInputFocused('inputBrandName')
      this.vflowInputFocused('selectedNetwork_')
      this.$emit('mnpin-provider-determined', this.determinedProvider)
    },
    takeCommonlyBrandSelection (name) {
      this.resetAll()
      this.applyBrandSelection('')
      if (name !== '' && this.isExistingBrand(name)) {
        this.applyBrandSelection(name)
      }
      this.$v.inputBrandName.$touch()
      this.$v.selectedNetwork_.$touch()
      this.vflowInputFocused('inputBrandName')
      this.vflowInputFocused('selectedNetwork_')
    },
    tryToDetermineProvider () {
      let skipNetworkSelect = false
      this.determinedProvider = null

      const brand = this.providerList.find((e) => {
        return (e.brandName === this.selectedBrandName)
      }, this)

      // Use lastInputBeforeApplied to detect provider code entered by user i. e. user searched for RSLC
      // and we have a brand with provider VICT first and RSLC second. currently we'll pick VICT but it would make
      // sense to check the users input for a provider code and i. e. pick RSCL instead of VICT in this case
      if (typeof brand !== 'undefined' && brand !== null) {
        this.determinedProvider = brand.mnpProvidersWithTariffs[0]
        // if user input was a provider code, ignore priority sorting and try to find matching provider by code
        if (this.lastInputBeforeApplied.length === 4 && `${brand.providerCodes}`.toLowerCase().includes(this.lastInputBeforeApplied.toLowerCase())) {
          brand.mnpProvidersWithTariffs.forEach(bp => {
            if (bp.code.toLowerCase() === this.lastInputBeforeApplied.toLowerCase()) {
              this.determinedProvider = bp
            }
          })
          skipNetworkSelect = true
        }

        if (this.withNetworkSelect && !skipNetworkSelect) {
          brand.mnpProvidersWithTariffs.forEach(bp => {
            // we are searching a matching provider if we
            // the provider selection can be invoked with or without brand network selection to get a more
            // qualified result (provider). if network selection is enabled, we'll only take the first occurring
            // provider if there's only one network assigned. if there's more than one network we will check
            // the matching network in the next foreach
            // without network selection we will take the first occurring provider for the selected brand
            // and don't care about the network
            if (!this.determinedProvider || this.selectableNetworks.length < 2) {
              this.determinedProvider = bp
            }

            // when network selection is enabled and there's more than one network for this brand try to get a
            // more qualified result
            bp.networks.key.forEach(n => {
              // if brand was selected, not brand provider was portable before, take the first one and don't care
              // about the network
              if (!this.determinedProvider && n === this.selectedNetwork_) {
                // skip non-portable provider
                this.determinedProvider = bp
              }
            })
          })
        }
      }

      if (this.determinedProvider && this.active_) {
        this.unportableFound_ = !this.determinedProvider.availableForPorting
        this.providerKey_ = this.determinedProvider.key
        this.providerCode_ = this.determinedProvider.code
        this.providerNetwork_ = this.withNetworkSelect ? this.selectedNetwork_ : this.determinedProvider.networks.key[0]
        this.relatedTariff_ = this.determinedProvider.relatedTariffs[0]
        if (this.determinedProvider && this.determinedProvider.availableForPorting) {
          if (this.storedSelectedTariff && this.storedSelectedTariff.tariffId !== '162') {
            this.setSelectedTariff(this.determinedProvider.relatedTariffs[0])
          }
        }
      } else {
        this.providerKey_ = ''
        this.providerCode_ = ''
        this.providerNetwork_ = ''
        this.relatedTariff_ = this.defaultNoMnpInTariff
        this.unportableFound_ = false
        this.unportableSelected_ = false
        this.setSelectedTariffToDefault()
      }

      if (this.determinedProvider && this.determinedProvider.availableForPorting) {
        this.$emit('mnpin-provider-determined', this.determinedProvider)
      }
      this.$v.$touch()

      return this.determinedProvider
    },
    reactOnUserInput () {
      this.isNavigatingInProviders = false
      this.isUserTyping = true
      this.focus = -1
      if (this.focus > this.filteredSortedFlaggedBrandSelectOptions().length) {
        this.focus = 0
      }

      // if input is empty, clear selection to reset
      if (this.inputBrandName === '' || !this.determinedProvider) {
        this.unportableFound_ = false
        this.unportableSelected_ = false
        this.selectedBrandName = ''
        this.setSelectedTariffToDefault()
      }
      if (this.inputBrandName !== '') {
        this.searchingBrand = true
      }

      if (!this.isExistingBrand(this.inputBrandName)) {
        this.resetProviderSelection()
      }

      this.getProviderListLength()

      this.$emit('mnpin-provider-determined', this.determinedProvider)

      this.$forceUpdate()
      this.componentKey++
    },
    itemSelection (item) {
      if (this.isExistingBrand(item)) {
        this.applyBrandSelection(item)
      } else {
        this.applyBrandSelection('')
      }

      // skip while initializing
      if (this.initialized) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.unportableFound_) {
              this.unportableSelected_ = true
            }
          })
        })
      }

      this.searchingBrand = false
    },
    isExistingBrand (name) {
      for (let i = 0; i < this.brandSelectOptions.length; i++) {
        if (this.brandSelectOptions[i].brandName === name) {
          return true
        }
      }

      return false
    },
    /**
     * @return {number}
     */
    findSelectedBrandFocus () {
      for (let i = 0; i < this.filteredSortedFlaggedBrandSelectOptions().length; i++) {
        if (this.filteredSortedFlaggedBrandSelectOptions()[i].brandName === this.selectedBrandName) {
          return i
        }
      }
      return 0
    },
    findSelectedBrand () {
      if (this.findSelectedBrandFocus()) {
        this.focus = this.findSelectedBrandFocus()
        this.scrollWhenSelectedProvider()
      } else {
        this.focus = 0
      }
    },
    scrollWhenSelectedProvider () {
      this.$nextTick(function () {
        if (document.querySelector('.focus') !== null && document.querySelector('.option-list') !== null) {
          document.querySelector('.option-list').scrollTop = document.querySelector('.focus').offsetTop
        }
      })
    },
    onFocusSelectField () {
      this.focus = -1
      this.unportableFound_ = false
      this.unportableSelected_ = false
      this.searchingBrand = true
      this.$nextTick(() => {
        this.scrollHandlerOnScroll()
      })
    },
    applyBrandSelection (name) {
      if (this.inputBrandName !== name) {
        this.lastInputBeforeApplied = this.inputBrandName
        // tracking for first choice
        if (this.doTracking) {
          const data = {
            micro_conversion_category: 'first provider selected',
            micro_conversion_value: name
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('micro conversion', data)
          }
          this.doTracking = false
        }
      }
      this.inputBrandName = name
      this.selectedBrandName = name
      this.selectedBrandName_ = name
      this.searchingBrand = false
      this.focus = 0

      // check if currently selected/stated network is a valid selection
      if (this.selectableNetworks.length === 0) {
        this.selectedNetwork_ = ''
      } else {
        if (this.selectableNetworks.length === 1 || !this.couldUseNetworkAsQualifier) {
          this.selectedNetwork_ = this.selectableNetworks[0]
        }
      }

      if (this.selectedNetwork_ !== '' && this.selectableNetworks.indexOf(this.selectedNetwork_) === -1) {
        this.selectedNetwork_ = ''
      }

      this.$nextTick(function () {
        this.tryToDetermineProvider()
      })
    },
    onSelectByReturnKey () {
      this.itemSelection(this.lastFocusedBrand)
      this.searchingBrand = false
      this.$refs.brandsearchinput.blur()
    },
    focusChanged (event) {
      if (event) {
        const el = this.$refs['dropdown' + this.$vnode.key]
        if (el !== undefined && el !== event.target && !el.contains(event.target)) {
        } else {
          if ((navigator.userAgent.indexOf('MSIE') !== -1) || (!!document.documentMode === true)) {
            if (document.getElementById('provider-select-input-field')) {
              document.getElementById('provider-select-input-field').tabIndex = 0
            }
          } else {
            this.$nextTick(function () {
              if (document.getElementById('provider-select-input-field')) {
                document.getElementById('provider-select-input-field').tabIndex = 0
              }
            })
          }
        }
      }
    },
    listItemMouseOver (index) {
      if (!this.scrollHandlerDragging) {
        this.focus = index
      }
    },
    listItemMouseLeave (index) {
      if (!this.scrollHandlerDragging) {
        this.focus = index
      }
    },
    onArrowKeyScroll (event) {
      let elHeight
      let y = 0
      const numEl = this.filteredSortedFlaggedBrandSelectOptions().length
      let prevent = false
      let scrollTo = y

      if (document.querySelector('.focus')) {
        elHeight = document.querySelector('.focus').offsetHeight
      } else {
        elHeight = 30
      }
      if (document.querySelector('.option-list')) {
        y = document.querySelector('.option-list').scrollTop
      }
      switch (event.keyCode) {
        // page up
        case 33:
          this.focus = 0
          scrollTo = 0
          prevent = true
          break
        // arrow up
        case 38:
          this.isNavigatingInProviders = true
          if (this.focus > 0) {
            this.focus--
          }
          if (this.focus === -1) {
            this.focus++
          }
          scrollTo = (this.focus * elHeight)
          prevent = true
          break
        // page down
        case 34:
          this.focus = numEl - 1
          scrollTo = (this.focus * elHeight)
          prevent = true
          break
        // arrow down
        case 40:
          this.isNavigatingInProviders = true
          if (this.focus < numEl - 1) {
            this.focus++
          }
          scrollTo = (this.focus * elHeight)
          prevent = true
          break
      }

      this.lastFocusedBrand = ''
      if (this.filteredSortedFlaggedBrandSelectOptions()[this.focus]) {
        this.lastFocusedBrand = this.filteredSortedFlaggedBrandSelectOptions()[this.focus].brandName
      }

      // ensure valid range
      if (scrollTo < 0) {
        scrollTo = 0
      }

      if (scrollTo > (numEl - 1) * elHeight) {
        scrollTo = (numEl - 1) * elHeight
      }

      if (document.querySelector('.option-list')) {
        document.querySelector('.option-list').scrollTop = scrollTo
      }

      if (prevent) {
        event.preventDefault()
      }
    },
    documentClick (e) {
      if (this.searchingBrand) {
        const el = this.$refs['dropdown' + this.$vnode.key]
        if (el && el !== e.target && !el.contains(e.target) && e.target.id !== 'brand-search-clear-input') {
          this.applyBrandSelection(this.selectedBrandName)
        }
      }
    },
    grabScrollEvent (e) {
      if (e.stopPropagation) {
        e.stopPropagation()
      }
    },
    calculateScrollRatio () {
      const sh = this.$refs.dropdownListContainer.scrollHeight
      const ch = this.$refs.dropdownListContainer.clientHeight
      return (ch / sh)
    },
    scrollHandlerOnDragStart (e) {
      e.preventDefault()
      this.scrollHandlerDragging = true
      this.scrollHandlerDragStartPos = this.$refs.scrollHandle.offsetTop
      this.scrollHandlerDragLastPageY = e.pageY
    },
    scrollHandlerOnDragCatch (e) {
      if (this.scrollHandlerDragging) {
        e.preventDefault()
      }
    },
    scrollHandlerOnDrag (e) {
      e.preventDefault()
      if (this.scrollHandlerDragging) {
        const sr = this.calculateScrollRatio()
        const ch = this.$refs.dropdownListContainer.clientHeight
        const delta = e.pageY - this.scrollHandlerDragLastPageY
        this.scrollHandlerDragLastPageY = e.pageY
        let cp = (this.scrollHandlerDragStartPos += delta)

        // boundaries
        if (cp < 10) {
          cp = 10
        }
        if (cp > ch - 30) {
          cp = ch - 30
        }

        const raf = window.requestAnimationFrame || window.setImmediate || function (c) {
          return setTimeout(c, 0)
        }

        raf(() => {
          this.$refs.dropdownListContainer.scrollTop += delta / sr
          this.$refs.scrollHandle.style.top = cp + 'px'
        })
      }
    },
    scrollHandlerOnDragEnd (e) {
      this.scrollHandlerDragging = false
    },
    scrollHandlerOnScroll (e) {
      if (!this.scrollHandlerDragging && this.$refs.dropdownListContainer) {
        const ch = this.$refs.dropdownListContainer.clientHeight
        const st = this.$refs.dropdownListContainer.scrollTop
        const sr = this.calculateScrollRatio()
        const raf = window.requestAnimationFrame || window.setImmediate || function (c) {
          return setTimeout(c, 0)
        }

        // scrollable
        if (sr < 1) {
          // calculate top position of scroll handler within list
          let ht = Math.floor(st * sr)
          if (ht < 10) {
            ht = 10
          }
          if (ht > ch - 30) {
            ht = ch - 30
          }

          raf(() => {
            if (this.$refs.scrollHandle) {
              this.$refs.scrollHandle.style.display = 'block'
              this.$refs.scrollHandle.style.top = ht + 'px'
            }
          })
        } else {
          raf(() => {
            // nothing to scroll
            if (this.$refs.scrollHandle) {
              this.$refs.scrollHandle.style.display = 'none'
            }
          })
        }
      }
    },
    filteredSortedFlaggedBrandSelectOptions () {
      const rearrangedOptions = []

      // add special flags
      this.filteredBrandSelectOptions().forEach(o => {
        rearrangedOptions.push({
          ...o,
          matchByBrandName: `${o.brandName}`.toLowerCase().indexOf(this.inputBrandName.toLowerCase()) === 0,
          matchedByCode: (this.inputBrandName.length === 4 && `${o.providerCodes}`.toLowerCase().includes(this.inputBrandName.toLowerCase())) ? this.inputBrandName.toUpperCase() : null
        })
      })
      // sort by matching type
      rearrangedOptions.sort(function (a, b) {
        if (a.matchByBrandName === b.matchByBrandName) {
          return 0
        }
        return a.matchByBrandName ? -1 : 1
      })

      // If the User is searching for an Provider we don't show the Top Providers anymore
      if (this.inputBrandName !== '') {
        return rearrangedOptions
      }

      const fullList = []

      // Top 5 Providers
      rearrangedOptions.forEach(item => {
        if (this.quickSelectionBrandIdent_().find(el => item.brandName === el) !== undefined) {
          item.frequency = 'high'
          fullList.push(item)
        }
      })

      // Remaining Providers
      rearrangedOptions.forEach(item => {
        if (this.quickSelectionBrandIdent_().find(el => item.brandName === el) === undefined) {
          item.frequency = 'low'
          fullList.push(item)
        }
      })
      return fullList
    },
    quickSelectionBrandIdent_: function () {
      return this.quickSelectionBrand.split(',').map(function (item) {
        return item.trim()
      })
    },
    findLastHighBrand: function (brand) {
      const list = this.filteredSortedFlaggedBrandSelectOptions().filter((item) => {
        return (item.frequency === 'high')
      })
      const last = list.pop()
      return last?.brandName === brand.brandName
    },
    filteredBrandSelectOptions () {
      return this.brandSelectOptions.filter((brand) => {
        return (
          `${brand.brandName}`.toLowerCase().indexOf(this.inputBrandName.toLowerCase()) >= 0 ||
          (this.inputBrandName.length === 4 && `${brand.providerCodes}`.toLowerCase().includes(this.inputBrandName.toLowerCase()))
        )
      })
    },
    trackAndShowBrandSearchInfoModal () {
      this.showBrandSearchInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'mnp provider search info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    findProviderTariff: function (brand) {
      let tariff = brand.mnpProvidersWithTariffs[0]?.relatedTariffs[0]
      if (this.inputBrandName.length === 4) {
        // try to find a special tariff for inserted provider code
        brand.mnpProvidersWithTariffs.forEach(bp => {
          if (bp.code.toLowerCase() === this.inputBrandName.toLowerCase()) {
            tariff = bp.relatedTariffs[0]
          }
        })
      }
      return tariff
    },
    tariffBasicFee: function (brand) {
      return brand.tariff?.basicFee || null
    },
    tariffPromoPrice: function (brand) {
      return brand.tariff?.promoPrices?.promoPrice || null
    },
    hasTariffPromoPrice: function (brand) {
      const promoPrice = this.tariffPromoPrice(brand)
      return promoPrice > 0 && promoPrice !== this.tariffBasicFee(brand)
    },
    formattedPriceWithOption: function (brand) {
      let price = this.tariffBasicFee(brand)
      price = this.brandPriceWithOption(price)
      return this.formatPrice(price)
    },
    formattedPromoPriceWithOption: function (brand) {
      let price = this.tariffPromoPrice(brand) ? this.tariffPromoPrice(brand) : this.tariffBasicFee(brand)
      price = this.brandPriceWithOption(price)
      return this.formatPrice(price)
    },
    formatPrice (price) {
      // explicit space before € in provider list only
      if (price) {
        return this.price(price)
      } else {
        // empty prices are not displayed (z.B. BILDmobil)
        return ''
      }
    },
    brandPriceWithOption (price) {
      if (price !== null && this.targetTariffOptions?.length) {
        price += this.targetTariffOptions[0].price
      }
      return price
    }
  },
  computed: {
    placeholderForInput () {
      if (this.isNavigatingInProviders || this.isUserTyping || this.inputBrandName.length > 0) {
        return ''
      } else { return this.$slots.txtPlaceholderSearchField[0].text }
    },
    ariaLiveForInput () {
      if (this.isNavigatingInProviders) {
        return 'polite'
      } else { return 'off' }
    },
    ariaLabelForInput () {
      return this.$slots.txtSearchFieldAltText[0].text
    },
    storedMNPProviders () {
      return this.$store.getters[`checkoutv2/${this.process}/_mnpData/providerList`]
    },
    storedMNProvidersLoadedStatus () {
      return this.$store.getters[`checkoutv2/${this.process}/_mnpData/providerListLoadingStatus`]
    },
    targetTariffOptions () {
      return this.$store.getters[`checkoutv2/${this.process}/_cart/targetTariffoptions`]
    },
    ...mapGetters('checkout/tariff', {
      defaultTariff: 'defaultTariff',
      storedSelectedTariff: 'selectedTariff',
      isKwkTariff: 'checkKwk',
      storedDefaultTariffLoadingStatus: 'defaultTariffLoadingStatus'
    }),
    showPrice: function () {
      return !this.$store.getters['checkoutv2/' + this.process + '/_cart/kwkToken'] // only show price if no kwk token is set
    },
    featurePromotion: function () {
      return this.showFeaturePromotion || this.showFeaturePromotionProviderOnly
    },
    validBrandSelected: function () {
      return this.isExistingBrand(this.selectedBrandName)
    },
    brandSelectOptions: function () {
      const brands = []

      this.providerList.forEach(brand => {
        brands.push({
          brandName: brand.brandName,
          providerCodes: '',
          tariff: this.findProviderTariff(brand)
        })

        brand.mnpProvidersWithTariffs.forEach(bp => {
          brands[brands.length - 1].providerCodes = brands[brands.length - 1].providerCodes + ' ' + bp.code
        })
      })

      function compare (a, b) {
        const na = a.brandName.toLowerCase()
        const nb = b.brandName.toLowerCase()
        if (na < nb) {
          return -1
        }
        if (na > nb) {
          return 1
        }
        return 0
      }

      return brands.sort(compare)
    },
    couldUseNetworkAsQualifier: function () {
      // check if a network select would be a qualifier or if it wont make sense
      // because i. e. there's only one provider with three networks or every selected network
      // will result in the same provider (if network selection is enabled we'll take the first provider
      // with the selected network key or prior use a provider code that the user entered)
      const providerCodes = []
      const firstProviderByNetwork = []
      if (this.isExistingBrand(this.selectedBrandName)) {
        const brand = this.providerList.find((e) => {
          return (e.brandName === this.selectedBrandName)
        }, this)

        if (this.lastInputBeforeApplied.length === 4 && `${brand.providerCodes}`.toLowerCase().includes(this.lastInputBeforeApplied.toLowerCase())) {
          return false
        }

        if (typeof brand !== 'undefined' && brand !== null) {
          brand.mnpProvidersWithTariffs.forEach(bp => {
            providerCodes.push(bp.code)
            bp.networks.key.forEach(n => {
              if (!firstProviderByNetwork[n]) {
                firstProviderByNetwork[n] = bp.code
              }
            })
          })
        }
      }

      // iterate through provider by network and check if a different network
      // will cause a different provider selection, only makes sense if we have at least two
      // providers
      let providerChangedWithNetwork = false
      if (providerCodes.length > 1) {
        let lastFoundProvider = null
        for (const providerCode of Object.values(firstProviderByNetwork)) {
          // take first provider
          if (lastFoundProvider !== null && lastFoundProvider !== providerCode) {
            providerChangedWithNetwork = true
          }
          lastFoundProvider = providerCode
        }
      }

      return (providerCodes.length > 1 && providerChangedWithNetwork)
    },
    selectableNetworks: function () {
      const networks = []
      if (this.isExistingBrand(this.selectedBrandName)) {
        const brand = this.providerList.find((e) => {
          return (e.brandName === this.selectedBrandName)
        }, this)

        if (typeof brand !== 'undefined' && brand !== null) {
          brand.mnpProvidersWithTariffs.forEach(bp => {
            if (bp.availableForPorting) {
              bp.networks.key.forEach(n => {
                if (networks.indexOf(n) === -1) {
                  networks.push(n)
                }
              })
            }
          })
        }
      }

      return networks
    },
    providerList: function () {
      let brands = this.storedMNPProviders
      if (this.mnpProvidersWithTariffs && this.mnpProvidersWithTariffs.length !== 0) {
        brands = this.mnpProvidersWithTariffs
      }

      function sortByBrandname (a, b) {
        const na = a.brandName.toLowerCase()
        const nb = b.brandName.toLowerCase()
        if (na < nb) {
          return -1
        }
        if (na > nb) {
          return 1
        }
        return 0
      }

      function sortByPriority (a, b) {
        const pa = a.priority
        const pb = b.priority
        if (pa > pb) {
          return -1
        }
        if (pa < pb) {
          return 1
        }
        return 0
      }

      if (brands !== null) {
        brands.forEach(brand => {
          brand.providerCodes = ''
          brand.mnpProvidersWithTariffs.forEach(bp => {
            brand.providerCodes = brand.providerCodes + ' ' + bp.code
          })
        })

        brands.forEach(brand => {
          // check for replacements
          const r = this.mnpOnlyBrandNameReplacements.find(rep => rep.origin === brand.brandName)
          if (r) {
            brand.brandName = r.new
          }

          // sort provider by priority
          brand.mnpProvidersWithTariffs.sort(sortByPriority)
        })

        return brands.sort(sortByBrandname)
      }

      return []
    }
  },
  validations () {
    return {
      inputBrandName: {
        required,
        found (v) {
          return this.selectedBrandName_ !== '' && this.isExistingBrand(this.selectedBrandName_) && this.determinedProvider !== null && !this.unportableFound_
        }
      },
      selectedNetwork_: {
        found (v) {
          if (this.selectedBrandName_ !== '' && this.withNetworkSelect && this.selectableNetworks.length > 1) {
            return v !== ''
          }

          return true
        }
      }
    }
  }
}
</script>
